import Skeleton from '@components/v2/ui/Skeleton/Skeleton';
import { Stack } from '@mui/material';
import { BRAND_TILE_AVATAR_SIZE, BRAND_TILE_WIDTH } from '../storeConnections.utils';

const LABEL_SKELETON_WIDTH = 64;

const BrandTileSkeleton = () => (
  <Stack
    spacing={1.5}
    useFlexGap
    sx={{ width: BRAND_TILE_WIDTH, flexShrink: 0, alignItems: 'center', px: 0.5, py: 1 }}
  >
    <Skeleton
      variant="rounded"
      width={BRAND_TILE_AVATAR_SIZE}
      height={BRAND_TILE_AVATAR_SIZE}
      sx={(theme) => ({ borderRadius: `${theme.shape.borderRadiusLg}px` })}
    />
    <Skeleton variant="text" width={LABEL_SKELETON_WIDTH} />
  </Stack>
);

export default BrandTileSkeleton;
